import React from 'react';

/**
 *
 * @param {Array} cities -- Array of cities, each with name and url segment
 * @param {function} renderFooterLink -- Callback to function defined in MobileMenu.js
 * @param {Object} specialty -- Contains name and url segment for Specialty
 * @returns {JSX.Element}
 * @constructor
 */
export const CityLinks = ({ cities, renderFooterLink, specialty }) => (
    <>
        {cities.map((city) =>
            renderFooterLink(
                `${specialty.url}${city.url}`,
                `${specialty.name}-${city.name}`,
                'TopProviderFooterLinks',
                city.name
            )
        )}
    </>
);
